// extracted by mini-css-extract-plugin
export var container = "y_c";
export var scrollableContent = "y_by";